import * as React from "react";

const baseClass = "rj-pulse-bet-markets__msg";

export class GeneralMessage extends React.Component<{
    modifier?: string,
    text: string
}, {}> {
    render() {
        const { modifier, text } = this.props;
        const cls = modifier ? `${baseClass} ${baseClass}--${modifier}` : baseClass;
        return (
            <div className={cls}>
                <span className="rj-pulsebet-markets__message-text">{text}</span>
            </div>
        )
    }

}